import useNotificationMessage from '@scripttag/widgets/hooks/useNotificationMessage';
import usePlaySoundClient from '@scripttag/widgets/hooks/usePlaySoundClient';
import usePrepareUnreadMessage from '@scripttag/widgets/hooks/usePrepareUnreadMessage';
import useBrowsedPageTracking from '@assets/hooks/widget/useBrowsedPageTracking';
import useDisplayPopups from '@assets/hooks/widget/useDisplayPopups';

export default function useDynamicWidgetImports({
  sessionId,
  hasInteracted,
  settings,
  postData,
  setOpenWelcomePopup,
  setOpenNewsletterPopup,
  campaigns,
  activeCampaigns,
  setActiveCampaigns
}) {
  // Load notification message hook (core functionality)
  const {
    notificationMessage,
    setCustomerReading,
    emptySoundNotification,
    emptyMessageNotification,
    refreshTimeoutNotificationMessage
  } = useNotificationMessage({sessionId, hasInteracted});

  const {countPlaySound = 0, countUnread = 0} = notificationMessage;

  // Load sound player hook
  const {soundPlayer} = usePlaySoundClient({count: countPlaySound, emptySoundNotification});

  // Load unread message hook
  usePrepareUnreadMessage({count: countUnread});

  // Load browsed page tracking hook
  useBrowsedPageTracking({settings, postData, hasInteracted});

  // Load display popups hook
  useDisplayPopups({
    settings,
    setOpenWelcomePopup,
    setOpenNewsletterPopup,
    campaigns,
    activeCampaigns,
    setActiveCampaigns
  });

  return {
    notificationMessage,
    setCustomerReading,
    emptyMessageNotification,
    refreshTimeoutNotificationMessage,
    soundPlayer
  };
}
